import type { OperationPeriod } from '../../../entities/bank-transaction/index.js';
import { formatStoredDateForPeople } from '../../../features/payment-view/index.js';
import { Button } from '../../../shared/ui/index.js';
import { SummaryNote } from '../../../widgets/year-summary/index.js';
import styles from './operation-subscription.module.css';

type OperationSubscriptionProps = {
  subscription: OperationPeriod;
  isUnmatching: boolean;
  onOpen: () => void;
  onUnmatch: () => void;
};

export const OperationSubscription = ({
  subscription,
  isUnmatching,
  onOpen,
  onUnmatch,
}: OperationSubscriptionProps) => (
  <section className={styles.subscription}>
    <SummaryNote tone="hint">
      Це списання підтверджує платіж підписки «{subscription.name}» за{' '}
      {formatStoredDateForPeople(subscription.dueDate)} і рахується в її категорії. Категорію
      змінюють у картці підписки.
    </SummaryNote>

    <div className={styles.actions}>
      <Button onClick={onOpen}>Відкрити підписку</Button>
      <Button variant="danger" busy={isUnmatching} onClick={onUnmatch}>
        Скасувати зіставлення з банку
      </Button>
    </div>
  </section>
);
